import React from 'react';
import { useRecoilState } from 'recoil';
import classNames from 'classnames';
import * as AppState from '../../../../AppState';
import './OpenHouseButton.scss'

const OpenHouseButton = (props: {className?: string, style?: React.CSSProperties, buttonClass?: string}) => {
	const [gsFilters, setGsFilters] = useRecoilState(AppState.gsFilters);

	return (
    <div className={`dropdown position-relative ${props.className}`} style={props.style}>
      <button
      id="hsOpenHouseFilterToggleButton"
      className={classNames(gsFilters.openHouse ? 'cc-btn--secondary homesearch-filters__cc-btn--active' : 'cc-btn--gray', props.buttonClass, 'cc-btn--outline', 'cc-btn cc-btn--reset-text justify-content-center', 'cc-btn cc-btn--outline cc-btn--reset-text justify-content-center cc-btn--navbar homesearch-filters__cc-btn--open-house')}
      type="button"
      onClick={()=>{setGsFilters({...gsFilters, openHouse: !gsFilters.openHouse})}}
      >
        <div>Open House</div>
    </button>
  </div>
	);
};

export default OpenHouseButton;
